import { useComboboxOptions } from '@/i18n/hooks/useComboboxOptions';
import { Button } from '@eye-able/ui';

interface PluralizationOverviewProps {
  pluralKeys: string[];
  selectedOption: {
    key: string;
    namespace: string;
  };
  onSelect: (value: string) => void;
}

export const PluralizationOverview = (props: PluralizationOverviewProps) => {
  const { pluralKeys, selectedOption, onSelect } = props;

  const { createUniqueValue } = useComboboxOptions();

  return (
    <div className={'eye:flex eye:gap-2xs'}>
      <div>
        <p>Pluralization key found!</p>
        <ul>
          <li>_one - singular</li>
          <li>_two - dual form (exactly 2 in some languages)</li>
          <li>
            _few - small plural group (typically 2-4 depending on language
            rules)
          </li>
          <li>
            _many - larger plural group (often 5+ or specific number patterns)
          </li>
        </ul>
      </div>
      <div className={'eye:flex eye:gap-2xs eye:items-center eye:justify-end'}>
        {pluralKeys.map((pluralKey) => (
          <Button
            key={pluralKey}
            variant={'outline'}
            size={'sm'}
            onClick={() =>
              onSelect(
                createUniqueValue({
                  key: pluralKey,
                  namespace: selectedOption.namespace,
                }),
              )
            }
          >
            _{pluralKey.split('_').pop()?.toUpperCase()}
          </Button>
        ))}
      </div>
    </div>
  );
};

PluralizationOverview.displayName = 'PluralizationOverview';
